import axios from 'axios'

export const getAllRoles = (params) => {
  return axios.get('/roles', {params: params})
}

export const getRole = (id, params) => {
  return axios.get('/roles/' + id, {params: params})
}

export const createRole = (data) => {
  return axios.post('/roles', data)
}

export const editRole = (id, data) => {
  return axios.put('/roles/' + id, data)
}

export const deleteRole = (id) => {
  return axios.delete('/roles/' + id)
}



// WEBPACK FOOTER //
// ./src/api/roles.js